import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  title: {
    id: 'report.details.title',
    defaultMessage: 'Tietoja päätöksenteon tueksi',
    description: 'Title for report details',
  },
  personnel_info: {
    id: 'report.details.employersInfo',
    defaultMessage: `<p>Työntekijöiden lukumäärällä ei ole välitöntä yhteyttä laadun tai luotettavuuden kanssa, mutta se on hyvä tietää vertailtaessa tarjouksia ja päätettäessä tapauskohtaisesti mikä yritys vastaa parhaiten omiin tarpeisiin.</p>
                     <p>Yrityksen työntekijämäärällä voi olla merkitystä tilattaessa suurempia urakoita, joissa suuremmat yritykset eivät välttämättä tarvitse alihankintaa. Henkilömäärältään pienempi yritys voi olla joskus soveliaampi erikoisosaamista vaativissa tehtävissä.</p>`,
    description: 'Details about companys employers',
  },
  personnel: {
    id: 'report.details.employeeCount',
    description: 'Number of employees',
    defaultMessage: 'Työntekijöiden määrä',
  },
  age_in_days_info: {
    id: 'report.details.companyAgeInfo',
    defaultMessage:
      '<p>Yrityksen iällä ei ole yksistään yhteyttä laatuun tai luotettavuuteen, mutta suuremmissa pitkiä vastuita tai takuita sisältävissä töissä kannattaa huomioida yrityksen ikä ja liikevaihto. Suuremmissa töissä yrityksen ikä ja liikevaihto suhteutettuna hankkeen hintaan antaa hyvää lisätietoa vertailtaessa eri yrityksiä.</p>',
    description: 'Details about companys age',
  },
  age_in_days: {
    id: 'report.details.age',
    description: 'Age of the company',
    defaultMessage: 'Yrityksen ikä',
  },
  turnover_info: {
    id: 'report.details.companyTurnoverInfo',
    defaultMessage:
      '<p>Liikevaihdolla ei ole välitöntä yhteyttä laatuun tai luotettavuuteen. Pitkiä vastuita tai takuita sisältävissä töissä kannattaa arvioida myös yrityksen kykyä hoitaa korjaus- tai takuuvastuut. Oman urakan kokonaishinta kannattaa suhteuttaa myös yrityksen kokoluokkaan ja ikään.</p>',
    description: 'Details about companys turnover',
  },
  turnover: {
    id: 'report.details.turnover',
    description: 'Turnover',
    defaultMessage: 'Liikevaihto',
  },
  vat_true_info: {
    id: 'report.details.companyVatInfo',
    defaultMessage: `<p>Yritys on arvonlisäverovelvollinen. Ja kuitissa tulisi näkyä yrityksen palveluihin liittyvä arvonlisäveroprosentti.</p>
                     <p>Varmista että kuitissa näkyy arvonlisävero, koska yritys on liiketoiminnasta ALV-velvollinen. Säilytä kuitti takuun varalta, kotitalousvähennyksen kannalta se pitää säilyttää vähintään 5 vuotta.</p>`,
    description: 'Details about VAT companys',
  },
  vat_false_info: {
    id: 'report.details.companyNoVatInfo',
    defaultMessage: `<p>Yrityksen ei kuulu laskuttaa arvonlisäveroa, varmista kuitista, että arvonlisäveroa ei ole laskutettu.</p>
                     <p>Yritys ei kuuluu ALV-rekisteriin. Yritys ei saa laskuttaa sinulta arvonlisäveroa, koska se ei ole arvonlisäverovelvollinen. Varmista että kuitissa on vain sovittu hinta.</p>`,
    description: 'Details about no-VAT companys',
  },
  vat_null_info: {
    id: 'report.details.companyNoVatInfo',
    defaultMessage: `<p>Yrityksen ei kuulu laskuttaa arvonlisäveroa, varmista kuitista, että arvonlisäveroa ei ole laskutettu.</p>
                     <p>Yritys ei kuuluu ALV-rekisteriin. Yritys ei saa laskuttaa sinulta arvonlisäveroa, koska se ei ole arvonlisäverovelvollinen. Varmista että kuitissa on vain sovittu hinta.</p>`,
    description: 'Details about no-VAT companys',
  },
  employer_yes_info: {
    id: 'report.details.registrationsEmployerYes',
    defaultMessage: `<p>Yritys kuuluu työnantajarekisteriin, ja sillä on palkattuja työntekijöitä.</p>
                     <p>Yritysten, joilla on yli kaksi työntekijää tai viisi tilapäistä työntekijää tulee kuulua työnantajarekisteriin.</p>`,
    description: 'Details about companys registrations (employers = yes)',
  },
  employer_yes_small_info: {
    id: 'report.details.registrationsEmployerYesSmall',
    defaultMessage: `<p>Yritys kuuluu työnantajarekisteriin, ja sillä on palkattuja työntekijöitä.</p>
                     <p>Yritysten, joilla on yli kaksi työntekijää tai viisi tilapäistä työntekijää tulee kuulua työnantajarekisteriin.</p>`,
    description: 'Details about companys registrations (employers = yes_small)',
  },
  employer_no_info: {
    id: 'report.details.registrationsEmployerNo',
    defaultMessage:
      '<p>Tietojen mukaan yrityksellä on enemmän kuin kaksi palkattua työntekijää. Kun yritys ei ole työnantajarekisterissä, sillä voi olla korkeintaan kaksi palkattua tai viisi tilapäistä työntekijää. Varmistathan ennen työn ostamista, että yritys hoitaa työnantajan velvoitteet ja maksaa työntekijöiden palkat ostamastasi työstä.</p>',
    description: 'Details about companys registrations (employers = no)',
  },
  employer_no_small_info: {
    id: 'report.details.registrationsEmployerNoSmall',
    defaultMessage:
      '<p>Yrityksellä voi olla korkeintaan kaksi palkattua työntekijää tai viisi tilapäistä työntekijää, koska yritys ei kuulu työnantajarekisteriin. Varmistathan, että työntekijöiden etu on huomioitu, kun teet sopimuksen yrityksen kanssa.</p>',
    description: 'Details about companys registrations (employers = no_small)',
  },
  employer_no_missing_info: {
    id: 'report.details.registrationsEmployerNoInfo',
    defaultMessage:
      '<p>Tietoa yrityksen työnantajarekisteriin kuulumisesta ei ole saatavilla</p>',
    description: 'No details about companys registrations',
  },
  tax_prepayment_no_info: {
    id: 'report.details.registrationsTaxNo',
    defaultMessage: '<p>Yritys ei kuulu ennakkoperintärekisteriin, joten et voi saada kotitalousvähennystä yrityksen tekemästä työstä.</p><p>Lue lisätietoja aiheesta <a target="_blank" href="https://www.vero.fi/henkiloasiakkaat/verokortti-ja-veroilmoitus/tulot-ja-vahennykset/kotitalousvahennys/">Verohallinnon sivuilta</a>.</p>',
    description: 'Details about companys tax prepayment (no)',
  },
  tax_prepayment_yes_info: {
    id: 'report.details.registrationsTaxYes',
    defaultMessage: '<p>Yritys kuuluu ennakkoperintärekisteriin, joten voit saada kotitalousvähennyksen, jos yritys tekee kotitalousvähennykseen oikeuttavaa työtä.</p><p>Tarkasta saatko kotitalousvähennyksen <a target="_blank" href="https://www.vero.fi/fi-FI/Henkiloasiakkaat/Kotitalousvahennys/Taulukko_kysytyimmista_kotitalousvahenny(9231)">Verohallinnon sivuilta</a>.</p>',
    description: 'Details about companys tax prepayment (yes)',
  },
  tax_prepayment_no_override_info: {
    id: 'report.details.registrationsTaxNoOverride',
    defaultMessage: '<p>Yritys kuuluu ennakkoperintärekisteriin, mutta on ilmoittanut, että ei tee kotitalousvähennykseen oikeuttavaa työtä.</p><p>Lue lisätietoja aiheesta <a target="_blank" href="https://www.vero.fi/henkiloasiakkaat/verokortti-ja-veroilmoitus/tulot-ja-vahennykset/kotitalousvahennys/">Verohallinnon sivuilta</a>.</p>',
    description: 'Details about companys tax prepayment (no_industry)',
  },
  tax_prepayment_no_missing_info: {
    id: 'report.details.registrationsTaxNoInfo',
    defaultMessage: '<p>Tietoja yrityksen kotitalousvähennyksestä ei ole saatavilla</p>',
    description: 'No details about companys tax prepayment',
  },
  accident_yes_info: {
    id: 'report.details.insurancesAccidentYes',
    defaultMessage: `<p>Yritys on vakuuttanut työntekijänsä työtapaturmien varalta. Lakisääteinen tapaturmavakuutus kattaa työssä, työpaikalla ja työmatkalla sattuneet tapaturmat ja ammattitaudit.</p>
                     <p>Selvitys perustuu Luotettava Kumppani -palveluun annettuihin tietoihin, ja se löytyy vain Luotettava Kumppani -yrityksiltä.</p>`,
    description: 'Details about companys insurance accident policy (yes)',
  },
  accident_no_small_info: {
    id: 'report.details.insurancesAccidentNoSmall',
    defaultMessage: `<p>Yrityksellä ei ole tapaturmavakuutusta. Tämä voi johtua siitä, ettei heillä ole palkattua työvoimaa.</p>
                     <p>Selvitys perustuu Luotettava Kumppani -palveluun annettuihin tietoihin, ja se löytyy vain Luotettava Kumppani -yrityksiltä.</p>`,
    description: 'Details about companys insurance accident policy (no_small)',
  },
  accident_no_large_info: {
    id: 'report.details.insurancesAccidentNoLarge',
    defaultMessage: `<p>Työnantajalla on velvollisuus ottaa tapaturmavakuutus työsuhteessa oleville työntekijöille. Yrityksellä ei ole selvityksen mukaan tapaturmavakuutusta, vaikka heillä on tietojen mukaan palkattuja työntekijöitä. Varmistathan ennen tilausta, että yrityksellä ei ole työntekijöitä tai että työntekijöille löytyy tarvittava tapaturmavakuutus.</p>
                     <p>Selvitys perustuu Luotettava Kumppani -palveluun annettuihin tietoihin, ja se löytyy vain Luotettava Kumppani -yrityksiltä.</p>`,
    description: 'Details about companys insurance accident policy (no_large)',
  },
  accident_null_info: {
    id: 'report.details.insurancesAccidentNoInfo',
    defaultMessage: `<p>Tarkasta tapaturmavakuutustodistus ennen sopimuksen tekemistä. Yrityksen lakisääteisestä tapaturmavakuutuksesta ei löydy tietoa, koska se ei ole mukana Luotettava Kumppani -palvelussa, jossa tiedot voi antaa.</p>
                     <p>Tämä tieto löytyy vain Luotettava Kumppani -yrityksiltä jos ne ovat ilmoittaneet sen.</p>`,
    description: 'No details about companys insurance accident policy',
  },
  liability_yes_info: {
    id: 'report.details.insurancesLiabilityYes',
    defaultMessage: `<p>Vastuuvakuutus voi antaa ostajalle lisäturvaa ostettuun työhön liittyvissä ikävissä vahingoissa. Toiminnan vastuuvakuutus korvaa tavallisesti vakuutetun yrityksen toiminnasta aiheutuneet henkilö- ja esinevahingot. Vastaavasti tuotevastuuvakuutus kattaa sen korvausvelvollisuuden, joka lain mukaan voi aiheutua yritykselle sen valmistaman tai maahantuoman tuotteen aiheuttamista vahingoista. Jos ostamaasi työhön liittyy merkittäviä vastuita, vakuutustodistus kannattaa tarkastaa aina ennen sopimuksen tekemistä.</p>
                     <p>Selvitys perustuu Luotettava Kumppani -palveluun annettuihin tietoihin, ja se löytyy vain Luotettava Kumppani -yrityksiltä.</p>`,
    description: 'Details about companys insurance liability (yes)',
  },
  liability_no_info: {
    id: 'report.details.insurancesLiabilityNo',
    defaultMessage: `<p>Yrityksellä ei ole vastuuvakuutusta. Huomioi tämä isoissa ja arvokkaissa hankinnoissa. Suuren vahingon sattuessa yrityksen omat resurssit voivat olla pienet tilanteen korjaamiseksi, ja voit pahimmassa tapauksessa joutua vastaamaan itse vahinkojen korjaamisesta.</p>
                     <p>Selvitys perustuu Luotettava Kumppani -palveluun annettuihin tietoihin, ja se löytyy vain Luotettava Kumppani -yrityksiltä.</p>`,
    description: 'Details about companys insurance liability (no)',
  },
  liability_null_info: {
    id: 'report.details.insurancesLiabilityNoInfo',
    defaultMessage: `<p>Yrityksellä ei ole vastuuvakuutusta tai se ei ole ilmoittanut sitä Luotettava Kumppani –palveluun. Vastuuvakuutus on vapaaehtoinen vakuutus.</p>
                     <p>Tieto vakuutuksesta löytyy vain Luotettava Kumppani -yrityksiltä, jos ne ovat ilmoittaneet sen.</p>`,
    description: 'No details about companys insurance liability',
  },
  luotettavaKumppani: {
    id: 'report.details.luotettavaKumppani',
    defaultMessage: `<p>Tarkasta tapaturmavakuutustodistus ennen sopimuksen tekemistä. Yrityksen lakisääteisestä tapaturmavakuutuksesta ei löydy tietoa.</p>
                     <p>Tämä tieto löytyy vain Luotettava Kumppani -yrityksiltä jos ne ovat ilmoittaneet sen.</p>`,
    description: 'Details about "luotettava kumppani"',
  },
  // SETI STUFF
  seti_a: {
    id: 'report.details.seti_a.description',
    defaultMessage: '<p>Vapaaehtoinen SETI-pätevyys kertoo yrityksen erityisosaamisesta, jonka lisäksi se tekee myös muita asennus- ja sähkötöitä.</p> <p>Pätevyystodistus takaa, että tekijöillä on koulutus ja työkokemusta antenniverkkotyöstä. Katso tarkat kriteerit <a href="{defaultUrlFi}">täältä</a>.</p>',
    description: 'Details about companys SETI qualification (A)',
  },
  seti_t: {
    id: 'report.details.seti_t.description',
    defaultMessage: `<h3>T-antenniurakoitsija</h3>
                     <p>Vapaaehtoinen SETI-pätevyys kertoo yrityksen erityisosaamisesta, jonka lisäksi se tekee myös muita asennus- ja sähkötöitä.</p>
                     <p>Pätevyystodistus takaa, että tekijöillä on koulutus ja työkokemusta tietoverkkotyöstä. Katso tarkat kriteerit <a href='http://setifi.asiakkaat.sigmatic.fi/index.php?k=20376'>täältä</a>.</p>                 `,
    description: 'Details about companys SETI qualification (T)',
  },
  seti_lk: {
    id: 'report.details.seti_lk.description',
    defaultMessage: '<p>Vapaaehtoinen SETI-pätevyys kertoo yrityksen erityisosaamisesta, jonka lisäksi se tekee myös muita asennus- ja sähkötöitä.</p> <p>Pätevyystodistus takaa, että tekijöillä on koulutus ja työkokemusta lämpökuvaamisesta. Katso tarkat kriteerit <a href="{defaultUrlFi}">täältä</a>.</p>',
    description: 'Details about companys SETI qualification (LK)',
  },
  seti_ol: {
    id: 'report.details.seti_ol.description',
    defaultMessage: '<p>Vapaaehtoinen SETI-pätevyys kertoo yrityksen erityisosaamisesta, jonka lisäksi se tekee myös muita asennus- ja sähkötöitä.</p> <p>Yritys täyttää vaadittavat urakoitsijakriteerit.</p> <p>OL-liityntäverkkotöillä (tietoliikenne) tarkoitetaan muun muassa jakamoteknisiä asennuksia, kuitujen asennuksia jatkoksissa ja päätteissä sekä kaapeleiden testauksia ja mittauksia. Urakoitsija tuntee myös liityntäverkon optisen kaapeloinnin suunnittelun ja mitoituksen periaatteet.</p> <p>OL-urakoitsijahyväksyntä takaa, että yrityksellä on nimetty vastuuhenkilö, jolla on vaadittava OL-asiantuntijasertifikaatti.</p> <p>Katso tarkat kriteerit <a href="{defaultUrlFi}">täältä</a>.</p>',
    description: 'Details about companys SETI qualification (OL)',
  },
  seti_rau: {
    id: 'report.details.seti_rau.description',
    defaultMessage: '<p>Vapaaehtoinen SETI-pätevyys kertoo yrityksen erityisosaamisesta, jonka lisäksi se tekee myös muita asennus- ja sähkötöitä.</p> <p>Yritys täyttää vaadittavat urakoitsijakriteerit.</p> <p>Rakennusautomaatiolla tarkoitetaan taloteknisiä järjestelmiä ja -prosesseja, joilla ohjataan, säädetään, valvotaan ja hallitaan muun muassa lämmönjako- ja ilmanvaihtojärjestelmiä ja/tai valaistus- ja sähköteknisiä järjestelmiä ja/tai tietoteknisiä järjestelmiä.<br />RAU-urakoitsijahyväksyntä takaa, että yrityksellä on nimetty rakennusautomaatiotöiden vastuuhenkilö, jolla on vaadittava pätevyys. Yritys on hoitanut yhteiskunnalliset vastuut kuten vero- ja työeläkemaksut. Katso tarkat kriteerit <a href="{defaultUrlFi}">täältä</a>.</p>',
    description: 'Details about companys SETI qualification (RAU)',
  },
  seti_tu: {
    id: 'report.details.seti_tu.description',
    defaultMessage: '<p>SETI Oy myöntää TU-sertifikaatin vaatimukset täyttävälle turvaurakoitsijalle, joka asentaa ja/tai ylläpitää sähköisiä turvallisuusjärjestelmiä, kuten paloilmoitin- ja murtoilmaisujärjestelmiä, kamera- ja kulunvalvontajärjestelmiä ja henkilöturvallisuusjärjestelmiä. SETI Oy:n TU-turvaurakoitsijasertifiointi on FINAS:n akkreditoima (S041). Katso tarkat kriteerit <a href="{defaultUrlFi}">täältä</a>.</p>',
    description: 'Details about companys SETI qualification (TU)',
  },
  seti_kt: {
    id: 'report.details.seti_kt.description',
    defaultMessage: '<p>Vapaaehtoinen SETI-pätevyys kertoo yrityksen erityisosaamisesta, jonka lisäksi se tekee myös muita asennus- ja sähkötöitä.</p> <p>Pätevyystodistus takaa, että tekijällä on kuntotukijakoulutus, vaadittavat sähköpätevyydet ja sähkötyöturvallisuuskoulutus. Tekijällä on pätevyys suorittaa kiinteistöjen sähkölaitteiden kuntotukimuksia, ja laatia niiden pohjalta kiinteistön kuntoarvio sekä mahdollinen korjaus- ja uusimisohjelma. Katso tarkat kriteerit <a href="{defaultUrlFi}">täältä</a>.</p>',
    description: 'Details about companys SETI qualification (KT)',
  },
  seti_kp: {
    id: 'report.details.seti_kp.description',
    defaultMessage: '<p>Vapaaehtoinen SETI-pätevyys kertoo yrityksen erityisosaamisesta, jonka lisäksi se tekee myös muita asennus- ja sähkötöitä.</p> <p>Pätevyystodistus takaa, että tekijällä on kunnossapitohyväksyntä, joka osoittaa luotettavuutta ja kelpoisuutta sähköalan kunnossapitotehtäviin. Katso tarkat kriteerit <a href="{defaultUrlFi}">täältä</a>.</p>',
    description: 'Details about companys SETI qualification (KP)',
  },
  seti_tt: {
    id: 'report.details.seti_tt.description',
    defaultMessage: '<p>Talotekniikkasertifikaatti myönnetään yritykselle, joka täyttää sertifiointiohjelman vaatimukset. Tämä voidaan myöntää kaikki toimialat käsittävänä kokonaisuutena tai erillisinä osa-alueina sähkö-, LVI-, turva- ja automaatiourakoitsijoille. SETI Oy:n TT-sertifikaatti on FINAS:n akkreditoima (S041). Katso tarkat kriteerit <a href="{defaultUrlFi}">täältä</a>.</p>',
    description: 'Details about companys SETI qualification (TT)',
  },

  // OTHERS
  readMore: {
    id: 'report.details.readMore',
    description: 'Read more',
    defaultMessage: 'Lue lisää',
  },
  readLess: {
    id: 'report.details.readLess',
    description: 'Read less',
    defaultMessage: 'Pienennä',
  },
});
